<template>
    <div v-if="returnGoodsType.length>0" :style="customStyle" class="goods-message">
        <template v-for="message in returnGoodsType">
            <p :class="message.class">{{message.content}}</p>
        </template>
    </div>
</template>
<script>
export default {
    name: 'goods-message',
    props: {
        goods:{
            type: Object,
            required: true
        },
        customStyle:{
            type:String,
            default:()=>{
                return '';
            }
        },
        notShow:{
            type:Array,
            default:()=>{
                return [];
            }
        }
    },
    data(){
        return {
            item:{}
        }
    },
    watch:{
        goods:{
            handler(newVal){
                this.item = newVal
            },
            deep: true
        }
    },
    mounted(){
        this.item = this.goods
    },
    computed:{
        returnGoodsType(){
            // 根据商品类型返回不同的商品类型,只返回一个活动类型，换购不改价格不涉及判断
            const typeMap = [
                {
                    id: 'seckill',
                    condition: () => this.item.promotion_label === 'seckill',
                    funKey: this.returnSeckillMessage
                },
                {
                    id: 'discount',
                    condition: () => this.item.promotion_label === 'discount',
                    funKey: this.returnDiscountMessage
                },
                {
                    id: 'wholesale',
                    condition: () => this.item.promotion_label === 'wholesale',
                    funKey: this.returnWholesaleMessage
                },
                {
                    id: 'getfree',
                    condition: () => !!this.item.is_getfree || !!this.item.get_free_goods,
                    funKey: this.returnGetfreeMessage
                }
            ];
            
            const foundType = typeMap.find(item => item.condition());
            if(foundType&&this.notShow.length>0&&this.notShow.includes(foundType.id)){
                // 包含则不显示
                return [];
            }else{
                return foundType ? foundType.funKey : [];
            }
            
        },
        
        // 秒杀商品信息提示判断
        returnSeckillMessage(){
            const messages = [];
            const { num, goods_min, goods_limit, price, discount_price } = this.item;
            
            // 检查必要参数
            if (num === undefined || goods_min === undefined) {
                return messages;
            }
            
            // 未满足最小购买数量提示
            if (num < goods_min) {
                messages.push(this._createMessage('redText',`提示：当前商品优惠起购数量为${goods_min}，小于${goods_min}将不享受优惠`));
                return messages;
            }
            
            // 无限购限制提示
            if (goods_limit == 0) {
                messages.push(this._createMessage('greenText', `提示：当前商品优惠不限制购买数量`));
                return messages;
            }
            
            // 有限购限制且已满足最小购买数量
            if (num >= goods_min && goods_limit > 0) {
                // 超出限购数量
                if (num > goods_limit) {
                    messages.push(this._createMessage('redText', `提示：您已超过限购数量${goods_limit}，超出部分恢复原价`));
                    
                    messages.push(this._createMessage('redText', `原价：￥${price} x ${num - goods_limit} 秒杀价：￥${discount_price} x ${goods_limit}`));
                } 
                // 未超出限购数量
                else if (num < goods_limit) {
                    messages.push(this._createMessage('redText', `提示：您还可购买${goods_limit - num}，超出部分恢复原价`));
                }
            }
            
            return messages;
        },
        
        // 特价商品信息提示判断
        returnDiscountMessage(){
            const messages = [];
            const { num, price, discount_price } = this.item;
            
            // 检查必要参数
            if (num === undefined || !this.item.promotion_info) {
                return messages;
            }
            
            const { goods_min, goods_limit, num_multiple } = this.item.promotion_info;
            
            // 未满足最小购买数量提示
            if (num < goods_min) {
                messages.push(this._createMessage('redText', `提示：当前商品优惠起购数量为${goods_min}，小于${goods_min}将不享受优惠`));
                return messages;
            }
            
            // 无限购限制提示
            if (goods_limit == 0) {
                messages.push(this._createMessage('greenText', `提示：当前商品优惠不限制购买数量`));
            }
            
            // 倍数购买逻辑
            if (num_multiple > 1 && num >= goods_min) {
                this._handleMultiplePurchase(messages, { num, price, discount_price, goods_min, goods_limit, num_multiple });
            } 
            // 非倍数购买且有限购逻辑
            else if (num >= goods_min && goods_limit > 0 && num_multiple <= 1) {
                this._handleNormalPurchase(messages, { num, price, discount_price, goods_limit });
            }
            
            return messages;
        },
        
        // 阶梯商品信息提示判断
        returnWholesaleMessage(){
            // 待实现
            return [];
        },
        // 换购商品信息提示判断
        returnGetfreeMessage(){
            let arr = [];
            if(!this.item||!this.item.get_free_goods||!this.item.get_free_goods.getFreeGoods){
                return arr;
            }
            let newArr = JSON.parse(JSON.stringify(this.item.get_free_goods.getFreeGoods));
            let mainObj = this.item.get_free_goods;
            let mainId = this.item.goods_id;
            let is_ladder = (mainObj.is_ladder>0?true:false);
            let default_unit = '盒';
            let mainUnit = this.item.unit?this.item.unit:'盒';
            let findIdex = newArr.findIndex((item) => {
                return item.goods_id === mainId;
            });
            // 副商品中的本品排在首位
            if(findIdex !== -1){
                let deletObj=newArr.splice(findIdex, 1)[0];
                let str = ''
                if(is_ladder){
                    if(typeof deletObj.ladder_json === 'string'){
                        deletObj.ladder_json = JSON.parse(deletObj.ladder_json)
                    }
                    deletObj.ladder_json.forEach((item1,index)=>{
                        if(this.item.num>=parseFloat(item1.mainRang)){
                            let str1=(item1.mainRang + mainUnit);
                            let str2=(parseFloat(item1.rangPrice)*parseFloat(item1.rang)).toFixed(2);
                            let str3=(item1.rang+(item1.unit?item1.unit:default_unit));
                            str = `单次购买本商品${str1}+${str2}元换购${str3}本品`;
                        }
                    })
                    if(str===''){
                        let min_num = Math.min(...deletObj.ladder_json.map(item4 => parseInt(item4.mainRang)));
                        str = `购买本商品${min_num}${mainUnit}，即可参与换购本品`;
                    }
                }else{
                    let str1=(deletObj.count + (deletObj.unit?deletObj.unit:default_unit));
                    let str2=(parseFloat(deletObj.price)*parseFloat(deletObj.num)).toFixed(2);
                    let str3=(deletObj.num+(deletObj.unit?deletObj.unit:default_unit));
                    str = `单次购买本商品${str1}+${str2}元换购${str3}本品`
                }
                arr.push({class:'greenText',content:str});
            };
            // 处理剩下副商品
            if(newArr.length>0){
                if(is_ladder){
                    let ladder_arr = [];
                    newArr.forEach((item1,index)=>{
                        if(typeof item1.ladder_json === 'string'){
                            item1.ladder_json = JSON.parse(item1.ladder_json)
                        }
                        let ladder_str = '';
                        let goodName = item1.goods.goods_name;
                        item1.ladder_json.forEach((item2,index)=>{
                            if(this.item.num>=parseFloat(item2.mainRang)){
                                let str1=(item2.mainRang + mainUnit);
                                let str2=(parseFloat(item2.rangPrice)*parseFloat(item2.rang)).toFixed(2);
                                let str3=(item2.rang+(item2.unit?item2.unit:default_unit));
                                ladder_str = `单次购买本商品${str1}+${str2}元换购${str3}${goodName}`;
                            }
                        });
                        if(ladder_str===''){
                            let min_num = Math.min(...item1.ladder_json.map(item4 => parseInt(item4.mainRang)));
                            ladder_str = `购买本商品${min_num}${mainUnit}，即可参与换购${goodName}`;
                        }
                        ladder_arr.push({class:'greenText',content:ladder_str});
                    })
                    arr = arr.concat(ladder_arr);
                }else{
                    let arr1 = [];
                    newArr.forEach((item1,index)=>{
                        let str1=(item1.count + (item1.unit?item1.unit:default_unit));
                        let str2=(parseFloat(item1.price)*parseFloat(item1.num)).toFixed(2);
                        let str3=(item1.num+(item1.unit?item1.unit:default_unit));
                        arr1.push({class:'greenText',content:`单次购买本商品${str1}+${str2}元换购${str3}${item1.goods.goods_name}`});
                    })
                    arr = arr.concat(arr1);
                }
            };
            return arr;
        }
    },
    
    methods: {
        // 创建消息对象
        _createMessage(className, content) {
            return {
                class: className,
                content: content
            };
        },
        
        // 处理倍数购买场景
        _handleMultiplePurchase(messages, { num, price, discount_price, goods_limit, num_multiple }) {
            // 倍数购买提示
            messages.push(this._createMessage('redText', `提示：当前特价仅${num_multiple}的倍数可享受，超出按原价计算`));
            
            // 超出限购
            if (goods_limit > 0 && num > goods_limit) {
                messages.push(this._createMessage('redText', `提示：您已超过限购数量${goods_limit}，超出部分恢复原价`));
                
                // 计算有效特价数量
                const quotient = Math.floor(goods_limit / num_multiple) * num_multiple;
                messages.push(this._createMessage('redText', `原价：￥${price} x ${num - quotient} 特价：￥${discount_price} x ${quotient}`));
            } 
            // 未超出限购或无限购限制
            else if (goods_limit == 0 || num <= goods_limit) {
                const remainder = num % num_multiple;
                if (remainder > 0&&num - remainder>0) {
                    messages.push(this._createMessage('redText', `原价：￥${price} x ${remainder} 特价：￥${discount_price} x ${num - remainder}`));
                }
            }
        },
        
        // 处理非倍数购买场景
        _handleNormalPurchase(messages, { num, price, discount_price, goods_limit }) {
            // 超出限购
            if (num > goods_limit) {
                messages.push(this._createMessage('redText', `提示：您已超过限购数量${goods_limit}，超出部分恢复原价`));
                messages.push(this._createMessage('redText', `原价：￥${price} x ${num - goods_limit} 特价：￥${discount_price} x ${goods_limit}`));
            } 
            // 未超出限购
            else if (num < goods_limit) {
                messages.push(this._createMessage('redText', `提示：您还可购买${goods_limit - num}，超出部分恢复原价`));
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.goods-message{
    display: flex;
    flex-direction: column;
}
.redText{
    color: #f56c6c;
    font-size: 12px;
    line-height: 16px;
    text-align: left;
}
.greenText{
    color: #31BB6D;
    font-size: 12px;
    line-height: 16px;
    text-align: left;
}
</style>